import React from 'react'
import { notification, message, Popover } from 'antd';
import Config from "../../../config/Config";
import WidgetAjax from '../../../widget/WidgetAjax';
import WidgetModal from '../../../widget/WidgetModal';
import NoData from '../../com/NoData';
import Map from "../../com/map";
import { formatSalaryRange, getSalaryDisplay, tagRedirect, checkLogin } from '../../com/utils'
import './detail_info.scss'
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class detail_info extends React.Component {
  constructor(props) {
    super(props)
    this.bodyRef = React.createRef();
    let job = this.props.location?.state?.data || {};
    this.state = {
      job: job || {},
      business: [
        { name: 'company-name', title: '公司名称', key: 'ENTNAME' },
        { name: 'company-type', title: '企业类型', key: 'INDTYPE_CN' },
        { name: 'res-time', title: '成立日期', key: 'ESTDATE' },
        { name: 'manage-state', title: '经营状态', key: 'REGSTATE_CN' },
        { name: 'company-fund', title: '注册资金', key: 'REGCAP' },
      ],
      similarData: [] //相似数据
    }

  }
  async componentDidMount() {
    const { job } = this.state;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    if (params) {
      // 获取指定参数的值
      const param1 = params.get('job_key');
      if (param1) {
        this.fetchJobInfo(param1);
      } else if (job && job?.id) {
        this.fetchJobInfo(job?.id);
      }

    }
    if (this.bodyRef.current) {
      this.bodyRef.current.addEventListener('scroll', this.handleScroll);
    }

    if (checkLogin) {
      this.getResume();
    }
   

  }

  componentWillUnmount() {

    if (this.bodyRef.current) {
      this.bodyRef.current.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll = () => {
    if (this.bodyRef.current) {
      if (this.bodyRef.current.scrollTop > 0) {
        this.setState({ sticky: true })
      } else {
        this.setState({ sticky: false })
      }
    }
  }


  componentDidUpdate(prevProps, prevState) {

  }

  ent_info = (id) => {
    WidgetAjax.ajax({
      url: path + "/enterprise/info",
      params: { id: id },
      callback: (res) => {
        if (res.status == 0) {
          this.setState({ ent_info: res.result });
        }
      },
    });
  }

  /**
   * 相似岗位
   */
  job_similar = () => {
    const { job } = this.state;
    let params = {
      type: 'labor',
      job_id: job?.id,
      page: 1,
      records: 3
    }
    const onSimilar = (res) => {
      if (res.status == 0) {
        this.setState({ similarData: res.results });
      }
    }
    WidgetAjax.ajax({ url: path + '/recommend/job_similar', params, callback: onSimilar });
  }


  getWechartShare = () => {
    const { job } = this.state;
    WidgetAjax.ajax({
      url: path + '/weixin/wmp_qrcode',
      params: {
        application: "wmp|pzz",
        scene: `shareID=${job.id}`,
        page: `pages/laborHome/postDetail/postDetail`
      },
      callback: (res) => {
        if (res.status == 0) {
          this.setState({ wechartCode: res.result.result })
        }
      }
    });
  }



  job_box = (data) => {
    return <>
      {
        data && data.length > 0 ?
          data.map((item) => {
            let SAL = formatSalaryRange(item?.SALFROM, item?.SALTO);
            let SALFROM = SAL[0];
            let SALTO = SAL[1];
            return <div className={`job_item`} onClick={() => { this.job_info(item) }}>
              <div className='sf-page-tool-between'>
                <div className='job_name'>
                  <div className='job_JOBNAME'>{item.JOBNAME}</div>
                  {
                    item.IMPORTANCE === '2' ?
                      <img className='job_jz' src={require("../../../img/pinzhunzhun/dataSource/jz.png")} /> : ""
                  }
                </div>
                <div className='job_SAL'>
                  {getSalaryDisplay(SALFROM, SALTO)}
                  {item.SALPAY == "11" ? "元/小时" : ""}
                  {item.SALPAY == "12" ? "元/天" : ""}
                  {item.SALPAY == "13" ? "元/周" : ""}
                </div>
              </div>
              <div className='require'>
                {item.REQWE_CN ? item.REQWE_CN : ""}
                {item.REQWE_CN ? <div className='line'>|</div> : ""}
                {!item.REQAGEFROM && !item.REQAGETO ? '不限年龄' : ""}
                {item.REQAGEFROM && !item.REQAGETO ? item.REQAGEFROM + '岁以上' : ""}
                {!item.REQAGEFROM && item.REQAGETO ? item.REQAGETO + '岁以内' : ""}
                {item.REQAGEFROM && item.REQAGETO ? item.REQAGEFROM + ' - ' + item.REQAGETO + '岁' : ""}
                {item.REQEDU_CN ? <div className='line'>|</div> : ""}
                {item.REQEDU_CN ? item.REQEDU_CN : ""}
              </div>
              <div className='job_tags'>
                {
                  item?.WELFARE && item?.WELFARE.length > 0 ? (
                    item.WELFARE.map((i) => {
                      return <div key={i} className='job_tag'>{i}</div>;
                    })
                  ) : null
                }
              </div>
              <div className='job_ent'>
                <div className='job_entName'>
                  <img className='job_logo' src={item?.ENTLOGO ? filePath + 'enterprise/M' + item.enterprise_id + '.png' : require('../../../img/pinzhunzhun/dataSource/ent_logo.png')} />
                  {item?.ENTNAME}
                </div>
              </div>
            </div>
          })
          : <NoData width={"230px"} height={'230px'} />
      }
    </>

  }



  application_add = (id) => {

    if (!checkLogin()) {
      message.warning('请先登录！');
      this.props.history.push({ pathname: "/login" });
      window.location.reload();
      return false;
    }

    const { resume } = this.state;
    console.log(resume,'resume--')
    if (resume && resume?.RIC && resume.RIC < 0.3 || resume.RIC == 0) return this.resumeRef.open()

    WidgetAjax.ajax({
      url: path + "/job/application_add",
      params: { job_id: id },
      callback: (res) => {
        if (res.status == 0) {

          this.fetchJobInfo(id);
          tagRedirect({ job_key: id }, 'sendNotice');
          notification.open({
            message: '报名成功',
            description: '报名成功',
            placement: 'top',
            duration: 2
          });
        }
      },
    });
  }

  job_info = (data) => {
    this.props.history.push({ pathname: "/home/jobdetails", state: { data } })
  }

  entInfo = (data) => {
    this.props.history.push({ pathname: "/home/enterprise/detail", state: { data } })
  }

  favor = (data) => {
    if (!checkLogin()) {
      message.warning('请先登录！');
      this.props.history.push({ pathname: "/login" });
      window.location.reload();
      return false;
    }
    let params = {
      job_id: data?.id,
    }
    const onFavor = (res) => {
      if (res.status == 0) {
        message.success("成功!");
        this.fetchJobInfo(data?.id);

      } else {
        message.error("失败");
      }
    }
    let url = data?.favor ? '/job/unfavor' : '/job/favor';
    WidgetAjax.ajax({ url: path + url, params, callback: onFavor });

  }

  // 用于获取职位信息的方法
  fetchJobInfo = (id) => {

    let params = { id };
    const onJobInfo = async (res) => {
      if (res.status === 0) {
        await this.setState({
          job: res.result,
          loading: false
        });
        this.ent_info(res.result?.enterprise_id)
        this.getWechartShare();
        this.job_similar();
      } else {
        console.error('获取职位信息失败:', res.message);
        this.setState({ loading: false });
      }
    };
    WidgetAjax.ajax({ url: path + '/job/info', params, callback: onJobInfo });
  };



  allJob = () => {
    const { ent_info } = this.state;
    this.props.history.push({ pathname: "/home/enterprise/detail", state: { data: ent_info } })
  }


  getResume = () => {
    const onResume = (res) => {
      if (res.status == 0) {
        this.setState({resume:res.result});
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onResume });
  }


  jump = () => {
    this.props.history.push({ pathname: "/home/resume" })
  }





  render() {
    const { job, wechartCode, ent_info, business, similarData, resume=undefined } = this.state;
    return <div component-data="detail_info">
      <div className='job-banner'>
        <div className='inner'>
          <div className='job-primary detail-box'>
            <div className='info-primary'>
              {/* <div className='job-status'><span>{job?.JOBSTATE_CN}</span></div> */}
              <div className='name'>
                <h1 title={job?.JOBNAME}>{job?.JOBNAME}</h1>
                <span className='salary'>
                  {getSalaryDisplay(job?.SALFROM, job?.SALTO)}
                  {job?.SALPAY == "11" ? "元/小时" : ""}
                  {job?.SALPAY == "12" ? "元/天" : ""}
                  {job?.SALPAY == "13" ? "元/周" : ""}
                </span>
              </div>
              <ul className='tag-list'>
                <li>
                  <img src={require("../../../img/pinzhunzhun/dataSource/icon-ADDRESS.png")} />
                  {job?.DISTRICT_CN}
                </li>
                <li >
                  <img src={require("../../../img/pinzhunzhun/dataSource/icon-exp.png")} />
                  {job?.REQWE_CN ? job.REQWE_CN : ""}
                </li>
                <li >
                  <img src={require("../../../img/pinzhunzhun/dataSource/icon-edu.png")} />
                  {job?.REQEDU_CN ? job.REQEDU_CN : ""}
                </li>
              </ul>
              <div className='job-op'>
                {
                  job?.favor ?
                    <a onClick={() => { this.favor(job) }} className='op-btn op-btn-likes'>取消收藏</a>
                    :
                    <a onClick={() => { this.favor(job) }} className='op-btn op-btn-like'>收藏</a>
                }
                {
                  job?.application ?
                    <a className='op-btn op-btn-chat' >已投递</a>
                    :
                    <a className='op-btn op-btn-chat' onClick={() => { this.application_add(job?.id) }}>立即投递</a>
                }
              </div>
            </div>
            {/* <div className='tag-container-new' >
              {
                job?.WELFARE && job?.WELFARE.length > 0 ?
                  <div className='job-tags'>
                    {
                      job?.WELFARE.map((item) => {
                        return <span>{item}</span>
                      })
                    }
                  </div>
                  : null
              }
              {
                job?.WELFARE && job?.WELFARE.length > 4 ?
                  <Popover
                    placement="bottomRight"
                    arrow={false}
                    content={
                      <div className='job-tags'>
                        {
                          job?.WELFARE.map((item) => {
                            return <span>{item}</span>
                          })
                        }
                      </div>
                    }>
                    <div className='tag-more'><span className='link-more'>...</span></div>
                  </Popover>
                  : null
              }
            </div> */}
          </div>
        </div>

      </div>

      <div className='job-box inner' style={{ marginTop: '216px' }}>

        <div className='job_info_body'>
          <div className='job-sider'>
            <div className='sider-company'>
              <p className='title'>相似职位</p>

              {
                similarData && similarData.map((item) => {
                  return <ul className='ent-similar-list' onClick={() => { tagRedirect({ job_key: item?.id }, 'JobDetails') }}>
                    <li >
                      <a>
                        <div className='similar-job-info'>
                          <span className='similar-job-name'>{item?.JOBNAME}</span>
                          <span className='similar-job-salary'>
                            {getSalaryDisplay(item?.SALFROM, item?.SALTO)}
                            {/* {job?.SALPAY == "11" ? "元/小时" : ""}
                            {job?.SALPAY == "12" ? "元/天" : ""}
                            {job?.SALPAY == "13" ? "元/周" : ""} */}
                            </span>
                        </div>

                        <div className='similar-job-attr'>
                          <span className='similar-job-company'>
                            <span className='job-company-logo'>
                              <img src={item?.ENTLOGO ? filePath + 'enterprise/M' + item.enterprise_id + '.png' : require('../../../img/pinzhunzhun/dataSource/ent_logo.png')} />
                            </span>
                            <span className='company-name'>{item?.ENTNAME}</span>
                          </span>
                          <span className='similar-job-location'>{item?.DISTRICT_CN}</span>
                        </div>

                      </a>

                    </li>

                  </ul>
                })
              }


              {/* <div className='company-info'>
                <img src={require("../../../img/pinzhunzhun/dataSource/ent_logo.png")} />
                <a> {ent_info?.ENTNAME}</a>
              </div> */}
              {/* <p><i className='icon-scale'></i>{ent_info?.SCALE_CN}</p>
              <p><i className='icon-industry'></i>{ent_info?.INDTYPE_CN}</p> */}
              <a className='look-all' onClick={() => { this.allJob() }}>查看全部职位</a>
            </div>
          </div>


          <div className='job-detail'>
            <div className='job-detail-box'>
              {
                <div className='sf-page-tool-between'>
                  <h3 className='job_info_title'>职位描述 </h3>
                  <Popover
                    placement="bottom"
                    arrow={false}
                    content={
                      <div className='wechat_share_box'>
                        <img src={`data:image/png;base64,${wechartCode}`} />
                        <div className='share_tips'>打开微信扫一扫</div>
                      </div>}>
                    <a className='link-wechat-share'>微信扫码分享</a>
                  </Popover>
                </div>
              }

              {
                job?.WELFARE && job?.WELFARE.length ?
                  <ul className='job-label-list'>
                    {job?.WELFARE.map((item) => {
                      return <li>{item}</li>
                    })}
                  </ul> : null
              }
              <div className='dangerouslySetInnerHTML' dangerouslySetInnerHTML={{ __html: job?.DETAIL }}></div>
              {/* <div className='job-boss-info'>
                <img src={require("../../../img/pinzhunzhun/dataSource/user_logo.png")} />
                <div className='detail-figure'>
                  <h2></h2>
                  <div className='boss-info-attr'>{job?.ENTNAME} </div>
                </div>
              </div> */}
              {/* <div className='job-address'>
                {
                  job?.ADDRESS ? <>
                    <span className='job-address-title'>工作地址</span>
                    <p className='job-address-desc'>{job?.ADDRESS} </p>
                  </>
                    : null
                }
                {
                  job?.LOCATION && job?.LOCATION.DISTRICT ? <div className='job-map_info'>
                    <Map lat={job.LOCATION.DISTRICT.LAT} lng={job.LOCATION.DISTRICT.LNG} />
                  </div> : null
                }
              </div> */}
            </div>


            <div className='ent_box job-detail-section'>
              <div className='job-detail-section-item'>
                <h3>公司介绍</h3>
                <div className='job-sec-text job-sec-text'>
                  {ent_info?.PROFILE}
                </div>
              </div>

              <div className='job-detail-section-item business-info-box'>
                <h3>工商信息</h3>
                <div className='level-list-box'>
                  <ul className='level-list'>
                    {business.map((item) => {
                      return <li className={item.name}>
                        <span>{item.title}</span> {item.key && ent_info?.[item.key] ? ent_info?.[item.key] : "-"}
                      </li>
                    })}
                  </ul>
                  {/* <a className='look-all'>查看更多</a> */}
                </div>
              </div>


              <WidgetModal onRef={ref => this.resumeRef = ref} onOk={() => this.jump()} options={{ title: '温馨提示', width: 500, isCancel: false, okText: '前往完善简历' }}>
                <div style={{ margin: '16px 0' }}>
                  您当前简历完整度为{resume?.RIC * 100 || 0}%，请您进一步完善简历后，再行投递！
                </div>
              </WidgetModal>


              <div className='detail-section-item company-address'>
                {
                  ent_info?.ADDRESS ?
                    <>
                      <h3>工作地址</h3>
                      <div className='job-location'>
                        <div className='location-address'>{ent_info?.ADDRESS}</div>
                        <div className='job-location-map'>
                          {
                            ent_info?.LOCATION?.DISTRICT ?
                              <Map lat={ent_info?.LOCATION?.DISTRICT?.LAT} lng={ent_info?.LOCATION?.DISTRICT?.LNG} /> : <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>暂无坐标</div>
                          }
                        </div>
                      </div>
                    </> : null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  }
}

export default detail_info;